module.exports = __webpack_public_path__ + "static/img/img4.aa41792b.png";